import i18n from '@/i18n';

export function setLocale(locale) {
  if (i18n.global.locale.value !== locale) {
    i18n.global.locale.value = locale;
  }
}

export function getLocale() {
  return i18n.global.locale.value;
}
